export default __webpack_public_path__ + "img/dstv.576179f4.png";